import { CONTACT } from "@/data/content";

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsappIntl}?text=${encodeURIComponent(msg || "Hello AquaFionix, I would like to inquire about your products.")}`;

export const mailLink = (subject, body) =>
  `mailto:${CONTACT.exportEmail}?subject=${encodeURIComponent(subject || "Export Inquiry — AquaFionix")}${
    body ? `&body=${encodeURIComponent(body)}` : ""
  }`;
